"use strict";

require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.regexp.constructor.js");
require("core-js/modules/es.regexp.to-string.js");
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _button = require("@citrus/button");
var _layout = require("@citrus/layout");
var _drawer = require("@citrus/drawer");
var _inputNumberStepper = require("@citrus/input-number-stepper");
var _inputSwitch = require("@citrus/input-switch");
var _tabs = require("@citrus/tabs");
var _reactGrid = require("@pcty/react-grid");
var _PctySurvey = require("./PctySurvey.Constants");
var _lodash = _interopRequireDefault(require("lodash.clonedeep"));
var _PctyGridRowCell, _PctyGridRowCell2, _PctyGridRowCell3, _PctyGridRowCell4;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ID_PREFIX = 'pcty-survey-settings';
var tabs = {
  TAKING: 1
};
var PctySurveySettings = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(PctySurveySettings, _React$Component);
  var _super = _createSuper(PctySurveySettings);
  function PctySurveySettings(props) {
    var _this;
    (0, _classCallCheck2.default)(this, PctySurveySettings);
    _this = _super.call(this, props);
    _this.state = {
      tab: 1,
      activeIndex: 0,
      settings: (0, _lodash.default)(props.settings)
    };
    _this.onClickChangeToTab1 = _this.onClickChangeToTab1.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClickChangeTab = _this.onClickChangeTab.bind((0, _assertThisInitialized2.default)(_this));
    _this.onToggleChange = _this.onToggleChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClickSave = _this.onClickSave.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChangeNumberStepper = _this.onChangeNumberStepper.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(PctySurveySettings, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (!nextProps.open) {
        this.setState({
          settings: (0, _lodash.default)(nextProps.settings)
        });
        this.setState({
          tab: tabs.TAKING
        });
      }
    }
  }, {
    key: "onClickChangeToTab1",
    value: function onClickChangeToTab1() {
      this.onClickChangeTab(tabs.TAKING, 0);
    }
  }, {
    key: "onClickChangeTab",
    value: function onClickChangeTab(tab, activeIndex) {
      this.setState({
        tab: tab,
        activeIndex: activeIndex
      });
    }
  }, {
    key: "onToggleChange",
    value: function onToggleChange(setting) {
      var settings = _objectSpread(_objectSpread({}, this.state.settings), {}, (0, _defineProperty2.default)({}, setting, !this.state.settings[setting]));
      this.setState({
        settings: settings
      });
    }
  }, {
    key: "onChangeNumberStepper",
    value: function onChangeNumberStepper(_ref) {
      var id = _ref.id,
        value = _ref.value;
      var setting = id.replace(new RegExp("^".concat(ID_PREFIX, "-")), '');
      var settings = _objectSpread(_objectSpread({}, this.state.settings), {}, (0, _defineProperty2.default)({}, setting, value));
      this.setState({
        settings: settings
      });
    }
  }, {
    key: "onClickSave",
    value: function onClickSave() {
      this.props.onClickSave(this.state.settings);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var renderActionArea = function renderActionArea() {
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_button.SecondaryButton, {
          onClick: _this2.props.onToggleDrawer
        }, "Cancel"), /*#__PURE__*/_react.default.createElement(_button.PrimaryButton, {
          onClick: _this2.onClickSave
        }, "Save"));
      };
      return /*#__PURE__*/_react.default.createElement(_drawer.Drawer, {
        id: "create-survey-settings-drawer",
        open: !!this.props.open,
        onClose: defaultFunction
      }, /*#__PURE__*/_react.default.createElement(_layout.Header, {
        title: "Settings",
        renderActionArea: renderActionArea
      }), /*#__PURE__*/_react.default.createElement(_tabs.Tabs, {
        activeIndex: this.state.activeIndex,
        type: "inset"
      }, /*#__PURE__*/_react.default.createElement(_tabs.Tab, {
        text: "Taking the Survey",
        onClick: this.onClickChangeToTab1
      })), this.renderDrawerContent());
    }
  }, {
    key: "renderDrawerContent",
    value: function renderDrawerContent() {
      var _this3 = this;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row pcty-border-top pcty-padding-all"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-12"
      }, /*#__PURE__*/_react.default.createElement(_reactGrid.PctyGrid, null, /*#__PURE__*/_react.default.createElement(_reactGrid.PctyGridRow, null, _PctyGridRowCell || (_PctyGridRowCell = /*#__PURE__*/_react.default.createElement(_reactGrid.PctyGridRowCell, null, "Duration")), /*#__PURE__*/_react.default.createElement(_reactGrid.PctyGridRowCell, {
        align: "right",
        width: 160
      }, /*#__PURE__*/_react.default.createElement(_inputNumberStepper.NumberStepper, {
        key: "".concat(ID_PREFIX, "-duration"),
        id: "".concat(ID_PREFIX, "-duration"),
        contentEditable: true,
        value: this.state.settings.duration,
        min: 0,
        onChange: this.onChangeNumberStepper
      }))), /*#__PURE__*/_react.default.createElement(_reactGrid.PctyGridRow, null, _PctyGridRowCell2 || (_PctyGridRowCell2 = /*#__PURE__*/_react.default.createElement(_reactGrid.PctyGridRowCell, null, "Questions will appear in order")), /*#__PURE__*/_react.default.createElement(_reactGrid.PctyGridRowCell, {
        align: "right"
      }, /*#__PURE__*/_react.default.createElement(_inputSwitch.Switch, {
        id: "".concat(ID_PREFIX, "-questions-in-order-switch"),
        compact: true,
        disabled: false,
        texton: "On",
        textoff: "Off",
        toggledOn: this.state.settings[_PctySurvey.SETTINGS.questionsInOrder],
        onChange: function onChange() {
          return _this3.onToggleChange(_PctySurvey.SETTINGS.questionsInOrder);
        }
      }))), /*#__PURE__*/_react.default.createElement(_reactGrid.PctyGridRow, null, _PctyGridRowCell3 || (_PctyGridRowCell3 = /*#__PURE__*/_react.default.createElement(_reactGrid.PctyGridRowCell, null, "One question will appear at a time")), /*#__PURE__*/_react.default.createElement(_reactGrid.PctyGridRowCell, {
        align: "right"
      }, /*#__PURE__*/_react.default.createElement(_inputSwitch.Switch, {
        id: "".concat(ID_PREFIX, "-one-question-at-a-time-switch"),
        compact: true,
        disabled: false,
        textOn: "On",
        textOff: "Off",
        toggledOn: this.state.settings[_PctySurvey.SETTINGS.oneQuestionAtATime],
        onChange: function onChange() {
          return _this3.onToggleChange(_PctySurvey.SETTINGS.oneQuestionAtATime);
        }
      }))), /*#__PURE__*/_react.default.createElement(_reactGrid.PctyGridRow, null, _PctyGridRowCell4 || (_PctyGridRowCell4 = /*#__PURE__*/_react.default.createElement(_reactGrid.PctyGridRowCell, null, "Display Questions in Pages")), /*#__PURE__*/_react.default.createElement(_reactGrid.PctyGridRowCell, {
        align: "right"
      }, /*#__PURE__*/_react.default.createElement(_inputSwitch.Switch, {
        id: "".concat(ID_PREFIX, "-display-questions-in-pages-switch"),
        compact: true,
        disabled: false,
        textOn: "On",
        textOff: "Off",
        toggledOn: this.state.settings[_PctySurvey.SETTINGS.displayQuestionsInPages],
        onChange: function onChange() {
          return _this3.onToggleChange(_PctySurvey.SETTINGS.displayQuestionsInPages);
        }
      }))), /*#__PURE__*/_react.default.createElement(_reactGrid.PctyGridRow, null, /*#__PURE__*/_react.default.createElement(_reactGrid.PctyGridRowCell, null, /*#__PURE__*/_react.default.createElement("span", {
        className: !this.state.settings[_PctySurvey.SETTINGS.oneQuestionAtATime] ? 'pcty-color-gray' : ''
      }, "Backward movement through survey is allowed")), /*#__PURE__*/_react.default.createElement(_reactGrid.PctyGridRowCell, {
        align: "right"
      }, /*#__PURE__*/_react.default.createElement(_inputSwitch.Switch, {
        id: "".concat(ID_PREFIX, "-backward-movement-switch"),
        compact: true,
        disabled: !this.state.settings[_PctySurvey.SETTINGS.oneQuestionAtATime],
        textOn: "On",
        textOff: "Off",
        toggledOn: !this.state.settings[_PctySurvey.SETTINGS.oneQuestionAtATime] ? false : this.state.settings[_PctySurvey.SETTINGS.backwardMovement],
        onChange: function onChange() {
          return _this3.onToggleChange(_PctySurvey.SETTINGS.backwardMovement);
        }
      })))))));
    }
  }]);
  return PctySurveySettings;
}(_react.default.Component);
var defaultFunction = function defaultFunction() {};
PctySurveySettings.propTypes = {
  /** A settings object contains the configuration of a survey. */
  settings: _propTypes.default.object.isRequired,
  /** Whether or not the settings drawer is open. */
  open: _propTypes.default.bool.isRequired,
  /** Callback function to set whether or not the settings drawer is open. */
  onToggleDrawer: _propTypes.default.func.isRequired,
  /** Callback function to get the updated settings. */
  onClickSave: _propTypes.default.func.isRequired
};
var _default = exports.default = PctySurveySettings;